import Client from "./clients/rest";


export default {

    getMenu(businessId, menuId) {
        return Client.get(`business/${businessId}/get_menu${(menuId ? "?menuId=" + menuId : "")}`);
    },

    quickOnlineUpdate(businessId, isOnLine) {
        return Client.post(`business/${businessId}/quick_online_managment?isOnLine=${isOnLine}`);
    },

    getCustomerImages(businessId) {
        return Client.get(`business/${businessId}/get_customer_images`);
    },

    uploadCustomerImage(businessId, typeId, imageIdToSwap, file) {
        const formData = new FormData();
        formData.append("file", file);
        return Client.post(`business/${businessId}/upload_customer_image?typeId=${typeId}&imageIdToSwap=${imageIdToSwap}`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
    },

    deleteCustomerImage(businessId, typeId) {
        return Client.post(`business/${businessId}/delete_customer_images_by_type?typeId=${typeId}`)
    },

    menuItemInsertOrUpdate(businessId, request) {
        return Client.post(`business/${businessId}/Menu_Item_Insert_Or_Update`, {
            ...request
        })
    },

    menuItemsInsertOrUpdate(businessId, request) {
        return Client.post(`business/${businessId}/Menu_Items_Insert_Or_Update`, request)
    },

    getMenuItem(businessId, id, parentId, type) {
        return Client.get(`business/${businessId}/get_menu_item?id=${id}&parentId=${parentId}&site=3&type=${type}`)
    },

    checkIfCustomerHaveLeadingTag(businessId) {
        return Client.get(`business/${businessId}/check_if_customer_have_leading_tag`)
    },

    menuItemImageUpload(businessId, menuItemId, file) {
        const formData = new FormData();
        formData.append("file", file);
        return Client.post(`business/${businessId}/menu_item_image_upload?menuItemId=${menuItemId}`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
    },

    menuItemImageDelete(businessId, menuItemId) {
        return Client.post(`business/${businessId}/menu_item_image_delete?menuItemId=${menuItemId}`)
    },

    DeleteItemsListFromMenu(businessId, items) {
        return Client.post(`business/${businessId}/delete_items_list_from_menu`, items)
    },

    updateOrderBy(businessId, items) {
        return Client.post(`business/${businessId}/update_order_by`, items)
    },

    importTabitMenu(businessId) {
        return Client.get(`business/${businessId}/import_tabit_menu`)
    },

    getMenuTimingData(businessId, menuId) {
        return Client.get(`business/${businessId}/get_menu_timing_data?menuId=${menuId}`)
    },

    postMenuTimingData(businessId, request) {
        return Client.post(`business/${businessId}/post_menu_timing_data`, request)
    },

    uploadMenuFile(businessId, menuType, tagId, file) {
        const formData = new FormData();
        formData.append("file", file);
        return Client.post(
            `business/${businessId}/upload_menu_file?menuType=${menuType}&tagId=${tagId}`,
            formData
        );
    },
    updateSingleMenuUrl(businessId, tagId, menuType, url) {
        return Client.post(`business/${businessId}/update-single-menu-url`, {
            TagId: tagId,
            Url: url,
            MenuType: menuType, 
            SiteId: 1,
            PlatformId: 1,
            LanguageId: 1
        });
    },
    getRestMenuInfo(businessId, tagId) {
        return Client.get(`business/${businessId}/get_rest_menu_info?tagId=${tagId}`)
    },


    updateDateMenuSettings(businessId, tagId, temporaryStartDate, temporaryEndDate, autoSwitchToTemporary) {
        return Client.post(`business/${businessId}/update_menu_date_settings?tagId=${tagId}`, {
            temporaryStartDate,
            temporaryEndDate,
            autoSwitchToTemporary
        });
    },

    deleteMenuFile(businessId, menuType, tagId) {
        return Client.post(
            `business/${businessId}/delete_menu_file?menuType=${menuType}&tagId=${tagId}`
        );
    },

};
